var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "chartWrapper", class: _vm.$.chart_wrapper }, [
    _c(
      "div",
      {
        class: [
          _vm.$.chart_body,
          _vm.flexGrow && _vm.$.flex_grow,
          "js_export_report_dymanic_chart",
        ],
      },
      [
        _c("div", { ref: "chart" }),
        _vm._v(" "),
        !_vm.dataExists && _vm.showStubMessage
          ? _c("div", { class: _vm.$.no_data_message }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.locale("chart_portfolio_milestones_date_no_items")
                  ) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [
          _vm.$.chart_legend,
          "export_html_milestone_chart_legend",
          _vm.small &&
            (_vm.$.no_padding,
            "export_html_milestone_chart_legend_no__padding"),
        ],
      },
      _vm._l(_vm.legend, function (item, i) {
        return _c(
          "div",
          {
            key: item.label,
            class: [
              _vm.$.legend_item,
              "export_html_milestone_chart_legend_item",
              !item.shouldFilter && [_vm.$.disabled, "disabled"],
            ],
            on: {
              click: function ($event) {
                return _vm.toggleLegendItem(i)
              },
            },
          },
          [
            _c("div", {
              class: [_vm.$.color_box, "export_html_color_box"],
              style: { backgroundColor: item.color },
            }),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(item.label))]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }